import { render, staticRenderFns } from "./left-menu.vue?vue&type=template&id=18d196d6&scoped=true&"
import script from "./left-menu.vue?vue&type=script&lang=js&"
export * from "./left-menu.vue?vue&type=script&lang=js&"
import style0 from "./left-menu.vue?vue&type=style&index=0&id=18d196d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d196d6",
  null
  
)

export default component.exports